import styled from 'styled-components';

export const Contain = styled.div`
  height: 100%;
  width: 98%;
  section {
    padding: 0 5px;
  }
`;
